import Loader from "../components/Loader";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import SubHeader from "../components/SubHeader";
import { UpdateStaffSchema } from "../auth/Schema";
import { Formik } from "formik";
import {
  fetchRoleCategories,
  updateStaffDetails,
} from "../redux/actions/staffActions";
import { pageRoutes } from "../routes/PageRoutes";
import ErrorMessage from "../components/ErrorMessage";
import Eye from "../components/Eye";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import Select from "react-select";
import "react-phone-number-input/style.css";

const EditTechnician = () => {
  const { isLoading1, roleOptions = [] } = useSelector(
    (state) => state?.staffReducer,
  );
  const stateObj = useLocation()?.state?.data || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isEye2, setIsEye2] = useState(false);
  const [isToggle, setIsToggle] = useState(false);

  useEffect(() => {
    dispatch(fetchRoleCategories());
  }, [dispatch]);

  const normalizedRoleValues = useMemo(() => {
    const rawRole = stateObj?.role;

    if (!rawRole) {
      return [];
    }

    if (Array.isArray(rawRole)) {
      return rawRole
        .map((item) => {
          if (typeof item === "number") {
            return item;
          }

          if (typeof item === "string") {
            const matchedOption = roleOptions.find(
              (option) =>
                String(option?.label).toLowerCase() === item.toLowerCase(),
            );
            return matchedOption?.value;
          }

          if (typeof item === "object") {
            return item?.id ?? item?.value;
          }

          return null;
        })
        .filter(Boolean);
    }

    if (typeof rawRole === "number") {
      return [rawRole];
    }

    if (typeof rawRole === "string") {
      return rawRole
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
        .map((item) => {
          const matchedOption = roleOptions.find(
            (option) =>
              String(option?.label).toLowerCase() === item.toLowerCase(),
          );
          return matchedOption?.value;
        })
        .filter(Boolean);
    }

    if (typeof rawRole === "object") {
      return [rawRole?.id ?? rawRole?.value].filter(Boolean);
    }

    return [];
  }, [roleOptions, stateObj?.role]);

  const initialState = useMemo(
    () => ({
      id: stateObj?.id || "",
      full_name: stateObj?.full_name || "",
      role: normalizedRoleValues,
      email: stateObj?.email || "",
      phone_no: stateObj?.phone_no || "",
      password: stateObj?.showPassword || "",
      home_address: stateObj?.home_address || "",
      hourly_rate: stateObj?.hourly_rate || "",
      status: stateObj?.status == 0 ? false : true,
    }),
    [normalizedRoleValues, stateObj],
  );

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const onHandleUpdateStaff = async (values, { setSubmitting }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes?.technicians);
      }
    };
    const data = {
      id: values?.id,
      name: values?.full_name?.trim(),
      role: values?.role ?? [],
      phone_no: values?.phone_no,
      password: values?.password,
      home_address: values?.home_address?.trim(),
      status: values?.status == true ? 1 : 0,
      hourly_rate: values.hourly_rate,
    };
    dispatch(updateStaffDetails({ payload: data, callback }));
  };

  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="container-fluid">
              <div className="ct_mb_30">
                <SubHeader />
              </div>

              <Formik
                enableReinitialize
                initialValues={initialState}
                validationSchema={UpdateStaffSchema}
                onSubmit={(values, actions) => {
                  onHandleUpdateStaff(values, actions);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldError,
                  setFieldValue,
                }) => {
                  const selectedRoleOptions =
                    roleOptions?.filter((option) =>
                      (values?.role ?? []).includes(option?.value),
                    ) ?? [];

                  return (
                    <form>
                      <div className="ct_white_bg_1 pb-5">
                        <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Name</strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="full_name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.full_name}
                              type="text"
                              className="form-control ct_input ct_transparent_input"
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="full_name"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Email </strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="email"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.email}
                              type="email"
                              className="form-control ct_input ct_transparent_input"
                              readOnly
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="email"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Password </strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <div className="position-relative">
                              <input
                                id="password"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values?.password}
                                type={isEye2 ? "text" : "password"}
                                className="form-control ct_input ct_transparent_input"
                              />
                              <Eye
                                className="ab_pointer"
                                isEye={isEye2}
                                onClick={() => setIsEye2(!isEye2)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="password"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Job Role</strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <Select
                              isMulti
                              inputId="role"
                              options={roleOptions || []}
                              placeholder="Select Job Role"
                              value={selectedRoleOptions}
                              onChange={(selectedOptions) =>
                                setFieldValue(
                                  "role",
                                  selectedOptions?.map((item) => item?.value) ??
                                    [],
                                )
                              }
                              onBlur={() =>
                                handleBlur({ target: { name: "role" } })
                              }
                              classNamePrefix="react-select"
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="role"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Contact no. </strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <PhoneInput
                              id="phone_no"
                              className="form-control ct_input ct_transparent_input "
                              defaultCountry="AU"
                              value={values?.phone_no}
                              onChange={(val) => {
                                const safeVal = val ?? "";
                                if (
                                  typeof safeVal === "string" &&
                                  safeVal.length > 2 &&
                                  isValidPhoneNumber(safeVal)
                                ) {
                                  setFieldValue("phone_no", safeVal);
                                } else if (!isValidPhoneNumber(safeVal)) {
                                  setFieldError(
                                    "phone_no",
                                    "Please enter valid phone number",
                                  );
                                  setFieldValue("phone_no", safeVal);
                                }
                              }}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="phone_no"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Hourly Rate ($)</strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="hourly_rate"
                              type="number"
                              className="form-control ct_input ct_transparent_input"
                              value={values.hourly_rate}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                if (newValue === "" || Number(newValue) >= 0) {
                                  handleChange(e);
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                  e.preventDefault();
                                }
                              }}
                              onWheel={() => document.activeElement.blur()}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="hourly_rate"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-3">
                            <label className="mb-1">
                              <strong>Home Address </strong>{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <textarea
                              id="home_address"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.home_address}
                              className="form-control ct_input ct_transparent_input"
                              rows="4"
                            ></textarea>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="home_address"
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group mb-3">
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <label className="mb-0">
                                <strong>Status </strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="status"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.status}
                                  checked={values.status}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="status"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-end gap-3 ct_mt_40">
                        {/* <button
                        type="button"
                       onClick={() => resetForm()}
                        class="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn"
                      >
                        Cancel
                      </button> */}
                        <button
                          type="button"
                          onClick={handleSubmit}
                          class="ct_border_radius_5 ct_h_40 ct_orange_btn"
                        >
                         Update
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTechnician;
